"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

const ReferringUrlScript = (): null => {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const populateReferringUrl = () => {
      const currentPageUrl = window.location.origin + window.location.pathname;
      const limitedCurrentPageUrl = currentPageUrl.slice(0, 200); // Limit to 200 characters
      const input = document.querySelector<HTMLInputElement>(
        'input[name="referringURL"][data-label="Referring URL"]',
      );

      if (!input) return;

      // Update property (used during form submission) 
      input.value = limitedCurrentPageUrl;

      // Update attribute (visible in DOM & DevTools)
      input.setAttribute("value", limitedCurrentPageUrl);
    };

    // Run immediately (covers initial render)
    populateReferringUrl();

    // Observe late-loaded Sitecore Forms
    const observer = new MutationObserver(() => {
      populateReferringUrl();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [pathname]); // Runs again on every route change

  return null;
};

export default ReferringUrlScript;
